import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/ContactUs.css';
import '../css/about.css';

const WellheadServices = () => {
  const underlineRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (underlineRef.current) {
        underlineRef.current.classList.add('animate');
      }
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0,    top: '-122px' }}>
            <div className="container about-content">
                <div className="row">
                    <div className="col-lg-6 col-md-8 col-12 about-text">
                        <h1 className="about-title text-white">Wellhead Services</h1>
                        <h2 className="about-subtitle">Wellhead Installation and Maintenance and Services</h2>
                        <div className="about-underline" ref={underlineRef}></div>
                        <p className="about-desc text-white" style={{ textAlign: "justify" }}>PetroChoice is your trusted partner for superior wellhead services and maintenance in the oil and gas industry. Our comprehensive offerings cover every aspect of well integrity, ensuring the longevity, safety, and efficiency of your operations.</p>
                    </div>
                </div>
            </div>
    </div>

      {/* What We Offer Section */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-8">
              <h2 className="fw-bold mb-4" style={{ color: '#0c61c0' }}>What We Offer</h2>
              <p className="mb-4">
                PETROCHOICE is a leading provider of wellhead installation, maintenance, and repair services. 
                We work with all wellhead brands, connection sizes, and working pressures from 3,000 to 20,000 
                pounds per square inch (PSI). We also offer solutions for hydrogen sulfide (H2S) corrosion 
                resistance and temperature variation, which are suitable for any wellhead connection type, 
                including Well heads X –Mass tree.
              </p>
            </div>
            <div className="col-lg-4">
              <img
                src={require('../assets/level2-600x402.jpg')} 
                alt="Wellhead Services"
                className="img-fluid rounded shadow"
              />
            </div>
          </div>
        </div>
      </div>

      {/* How We Work Section */}
      <div className="container-xxl py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-4">
              <img
                src={require('../assets/med.png')} 
                alt="How We Work"
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-lg-8">
              <h2 className="fw-bold mb-4" style={{ color: '#0c61c0' }}>How We Work</h2>
              <p className="mb-4">
                Our highly experienced service engineers use mobile service units to perform maintenance and 
                testing tasks on site, ensuring quality and efficiency. We follow the best industry practices 
                and safety standards to deliver reliable and cost-effective services.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-8">
              <h2 className="fw-bold mb-4" style={{ color: '#0c61c0' }}>Why Choose Us</h2>
              <p className="mb-4">
                In addition to our wellhead services, we also have fully equipped workshop facilities for major 
                overhauls and repairs, refurbishment of wellhead components, and supply of valve lubricants, 
                sealants, spare parts and flushing compounds. We are committed to providing excellent customer 
                service and satisfaction.
              </p>
            </div>
            <div className="col-lg-4">
              <img
                src={require('../assets/integrated.jpg')} 
                alt="Why Choose Us"
                className="img-fluid rounded shadow"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Maintenance Benefits Section */}
      <div className="container-xxl py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="fw-bold mb-4 text-center" style={{ color: '#0c61c0' }}>
                How to Save Time and Money with Wellhead Maintenance Services
              </h2>
              <div className="alert alert-info text-center mb-4">
                <strong>Did you know that regular wellhead maintenance can reduce the risk of costly repairs 
                and well shutdowns by up to 50%?</strong>
              </div>
              <p className="text-center mb-4">
                At PETROCHOICE, we offer planned maintenance of wellhead valves, seals, flanges, and other 
                components to extend the life of your wellhead system.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* PMR Services Section */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="fw-bold mb-4" style={{ color: '#0c61c0' }}>
                How to Optimize Your Wellhead Performance with PMR Services
              </h2>
              <p className="mb-4">
                Do you want to extend the life of your wellhead system, prevent costly repairs and shutdowns, 
                and ensure the safety and efficiency of your oil and gas production? If so, you need our PMR services. 
                PMR stands for Planned Maintenance Routines, which are periodic inspections, tests, and repairs of 
                your wellhead components.
              </p>
              
              <h3 className="fw-bold mb-3" style={{ color: '#0c61c0' }}>What are PMR Services?</h3>
              <p className="mb-4">
                PMR services are essential for maintaining the optimal performance and integrity of your wellhead 
                system. They help you avoid leaks, corrosion, damage, and malfunctions that can compromise your oil 
                and gas production and pose safety and environmental risks. PMR services also help you comply with 
                the industry standards and regulations for wellhead operations.
              </p>

              <h4 className="fw-bold mb-3">We offer the following services for all PMR:</h4>
              <ul className="list-unstyled">
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We inspect your wellhead system for any signs of wear and tear, damage, or malfunction.</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We test your wellhead system for its functionality, pressure integrity, and alignment.</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We lubricate your wellhead valves, seals, flanges, and actuators to prevent friction and corrosion.</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We repair or replace any faulty components on site or in our workshop, using our mobile service units and experienced service engineers.</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We support your well intervention operations on site, using our fully equipped facilities and quality materials.</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We provide Connection torquing</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We provide High pressure lubricator for setting and retrieval of Back Pressure Valves (BPV)</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We procure and deliver any spare parts you may need, using our extensive inventory and fast delivery.</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i>We provide you with a dedicated support team of personnel to execute the work, ensuring quality and efficiency.</li>
              </ul>

              <h4 className="fw-bold mb-3 mt-4">By choosing our PMR services, you can enjoy the following benefits:</h4>
              <ul className="list-unstyled">
                <li className="mb-2"><i className="bi bi-arrow-right-circle-fill text-primary me-2"></i>You can save time and money by avoiding frequent and expensive repairs and shutdowns.</li>
                <li className="mb-2"><i className="bi bi-arrow-right-circle-fill text-primary me-2"></i>You can ensure the reliability and safety of your wellhead system by preventing leaks, corrosion, and damage.</li>
                <li className="mb-2"><i className="bi bi-arrow-right-circle-fill text-primary me-2"></i>You can optimize the performance and efficiency of your wellhead system by maintaining the optimal pressure and flow of oil and gas.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Corrective Maintenance Section */}
      <div className="container-xxl py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="fw-bold mb-4" style={{ color: '#0c61c0' }}>Corrective Maintenance Services</h2>
              <p className="mb-4">Our corrective maintenance services involve the following steps:</p>
              <ul className="list-unstyled">
                <li className="mb-2"><i className="bi bi-tools text-warning me-2"></i>We repair any faulty components on site as much as possible, using our mobile service units and experienced service engineers.</li>
                <li className="mb-2"><i className="bi bi-tools text-warning me-2"></i>We refurbish any damaged or worn-out components in our workshop, using our fully equipped facilities and quality materials.</li>
                <li className="mb-2"><i className="bi bi-tools text-warning me-2"></i>We replace any irreparable components with new ones, using our extensive inventory and fast delivery.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Our Clients Section */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="fw-bold mb-4 text-center" style={{ color: '#0c61c0' }}>Our Clients</h2>
              <div className="row g-4 justify-content-center">
                <div className="col-md-6 col-lg-4">
                  <div className="card h-100 text-center">
                    <div className="card-body">
                      <h5 className="card-title">Badr El Din Petroleum Company</h5>
                      <p className="card-text text-muted">Egypt</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="card h-100 text-center">
                    <div className="card-body">
                      <h5 className="card-title">El Waha Petroleum Company</h5>
                      <p className="card-text text-muted">Libya</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default WellheadServices;
